import {
  DownArrowIcon,
  BasketHeaderIcon,
  SignUp,
  UserLogin,
} from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { Row } from '@components/formStyles';
import { toLocalePoint } from '@utils/utils';
import { SeturLoyaltyPointsViewModel } from '@api/v3';
import { useBasketId } from '@hooks/cache';
import { signUpGtm } from '@utils/gtm/membership-gtm';
import { useHotelDifference } from '@contexts/hotel-diff/HotelDifferenceContext';
import useGetasPath from '@hooks/useGetasPath';
import { CriteoUserInformation } from '@integrations/CriteoUserInfo';
import RouterLink from '@components/ui/RouterLink';

import {
  HeaderBox,
  HeaderBoxText,
  HeaderBoxWrapper,
  ProfileName,
  SignUpWrapper,
  StyledSimpleButton,
  BasketBox,
  VerticalLine,
} from './HeaderStyles';
import FormattedProfileName from '../components/ProfileName';
import BasketItemsCount from '../components/BasketItemsCount';
import { UserText } from '../Transparent/TransparentStyles';
import Difference from './difference';

const DesktopHeaderContent = ({
  displayPoints,
  profileName,
  toggleProfileMenu,
  seturPoints,
  basketHref,
}: {
  displayPoints?: boolean;
  profileName?: string;
  toggleProfileMenu?: () => void;
  seturPoints?: SeturLoyaltyPointsViewModel | null;
  basketHref?: string;
}) => {
  const asPath = useGetasPath();
  const basketId = useBasketId();
  const { visibleInHeader, diffData, removeDiffData } = useHotelDifference();

  CriteoUserInformation();
  return (
    <HeaderBoxWrapper hasPoints={displayPoints}>
      <HeaderBox>
        <Row alignItems='center'>
          <HeaderBoxText>
            {profileName ? (
              <SignUpWrapper>
                <StyledSimpleButton onClick={toggleProfileMenu}>
                  <FormattedProfileName profileName={profileName} />{' '}
                  <CustomIcon icon={DownArrowIcon} fontSize={14} />
                </StyledSimpleButton>
                <ProfileName>
                  {seturPoints
                    ? `${
                        toLocalePoint(seturPoints?.seturPoint ?? 0) || 0
                      }₺ Setur Puan`
                    : null}
                </ProfileName>
              </SignUpWrapper>
            ) : (
              <>
                <SignUpWrapper>
                  <RouterLink
                    href='/uye-ol/setur-extra'
                    rel='nofollow'
                    title='Üye Ol'
                    onClick={() => {
                      signUpGtm('{{Menü - Hemen Üye Ol}}');
                    }}
                  >
                    <UserText>
                      <CustomIcon icon={SignUp} fontSize={18} />
                      Üye Ol
                    </UserText>
                  </RouterLink>
                  <VerticalLine />
                  <RouterLink
                    href={`/giris-yap?redirectUrl=${encodeURIComponent(
                      asPath
                    )}`}
                    rel='nofollow'
                    title='Giriş Yap'
                    onClick={() => {
                      signUpGtm('{{Menü - Hemen Üye Ol}}');
                    }}
                  >
                    <UserText>
                      <CustomIcon icon={UserLogin} fontSize={18} />
                      Giriş Yap
                    </UserText>
                  </RouterLink>
                </SignUpWrapper>
              </>
            )}
          </HeaderBoxText>
          {visibleInHeader ? (
            <Difference diffData={diffData} removeDiffData={removeDiffData} />
          ) : null}
          <RouterLink title='Seyahat Planlama' href={`/${basketHref}`}>
            <BasketBox>
              <CustomIcon
                icon={BasketHeaderIcon}
                width={24}
                height={24}
                paletteColor='D400'
              />
              {basketId && basketId?.length > 0 ? (
                <BasketItemsCount basketId={basketId} />
              ) : null}
            </BasketBox>
          </RouterLink>
        </Row>
      </HeaderBox>
    </HeaderBoxWrapper>
  );
};

export default DesktopHeaderContent;
